// extracted by mini-css-extract-plugin
export default {"certificationsContainer":"Certifications_certificationsContainer__ZL8vq","content":"Certifications_content__PnIDD","header":"Certifications_header__oBh-9"};